/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LatestHotelEmailRequest
 */
export interface LatestHotelEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof LatestHotelEmailRequest
     */
    userId: string;
}

/**
 * Check if a given object implements the LatestHotelEmailRequest interface.
 */
export function instanceOfLatestHotelEmailRequest(value: object): value is LatestHotelEmailRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function LatestHotelEmailRequestFromJSON(json: any): LatestHotelEmailRequest {
    return LatestHotelEmailRequestFromJSONTyped(json, false);
}

export function LatestHotelEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LatestHotelEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
    };
}

export function LatestHotelEmailRequestToJSON(json: any): LatestHotelEmailRequest {
    return LatestHotelEmailRequestToJSONTyped(json, false);
}

export function LatestHotelEmailRequestToJSONTyped(value?: LatestHotelEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
    };
}

